import styled from "styled-components";
import { Button } from "@pepdirect/v3/ui/Button";
import { Device } from "@pepdirect/v3/styles/screenSizes";

export const StyledWrapper = styled.div<{ isPortal?: boolean }>`
  @media ${Device.laptop} {
    ${({ isPortal }) => (isPortal ? `max-width: 620px;` : `max-width: 420px;`)}
  }
`;

export const StyledRequiredFields = styled.div`
  font-size: 13px;
  margin-bottom: 16px;
`;

export const StyledRegion = styled.div`
  font-size: 13px;
  margin-bottom: 16px;
  font-weight: bold;
`;

export const StyledAutocompleteWrapper = styled.div`
  height: 60px;
  margin-bottom: 25px;
`;

export const StyledManualEnterButton = styled(Button)`
  font-size: 13px;
  color: ${({ theme }) => theme.color.primary};
  text-decoration: underline;
  margin-bottom: 25px;
`;

export const StyledManualEnterFields = styled.div<{ show: boolean }>`
  ${({ show }) =>
    !show &&
    `
    visibility: hidden;
    height: 0;
  `}
`;

export const StyledStateZipCountry = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

export const StyledState = styled.div`
  flex: 1;
  width: 100%;
  @media ${Device.notMobile} {
    max-width: 90px;
    width: auto;
  }
`;

export const StyledZip = styled.div`
  width: 100%;
  max-width: 50%;
  @media ${Device.notMobile} {
    flex: 1;
    min-width: 119px;
    width: auto;
  }
`;

export const StyledCountry = styled.div<{ show: boolean }>`
  ${({ show }) =>
    !show &&
    `
    display: none;
  `}
  flex: 1;
  width: 100%;
  min-width: 119px;
  @media ${Device.notMobile} {
    width: auto;
  }
`;
